/* NX store component kit: behaviour. Vanilla, ~6 KB, no dependencies. Every module no-ops when its markup is absent. */
(function () {
  'use strict';
  var d = document, de = d.documentElement;
  de.classList.add('nx-js');
  var $ = function (s, r) { return (r || d).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || d).querySelectorAll(s)); };
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var cfg = {};
  try { cfg = JSON.parse(($('#nx-config') || {}).textContent || '{}'); } catch (e) {}
  var cur = function () { return (window.Shopify && Shopify.currency && Shopify.currency.active) || cfg.currency || 'USD'; };
  var rate = function () { return parseFloat(window.Shopify && Shopify.currency && Shopify.currency.rate) || 1; };
  var nf = {};
  function money(cents, code) {
    code = code || cur();
    try {
      nf[code] = nf[code] || new Intl.NumberFormat(de.lang || undefined, { style: 'currency', currency: code });
      return nf[code].format(cents / 100);
    } catch (e) { return (cents / 100).toFixed(2) + ' ' + code; }
  }
  window.NX = { money: money, cart: null };

  /* reveal on scroll (IntersectionObserver; no library) */
  function reveal(root) {
    var els = $$('[data-nx-reveal]:not(.is-in)', root);
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (x) { if (x.isIntersecting) { x.target.classList.add('is-in'); io.unobserve(x.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (e) { io.observe(e); });
  }

  /* announcement bar rotation */
  function announce() {
    $$('[data-nx-announce]').forEach(function (bar) {
      var msgs = $$('.nx-announce__msg', bar); if (msgs.length < 2) return;
      var i = 0, t, ms = (parseInt(bar.getAttribute('data-speed'), 10) || 5) * 1000;
      bar.classList.add('is-rotating'); msgs[0].classList.add('is-on');
      function go(n) { msgs[i].classList.remove('is-on'); i = (n + msgs.length) % msgs.length; msgs[i].classList.add('is-on'); }
      function start() { if (!reduce) t = setInterval(function () { go(i + 1); }, ms); }
      function stop() { clearInterval(t); }
      var p = $('[data-prev]', bar), n = $('[data-next]', bar);
      if (p) p.addEventListener('click', function () { stop(); go(i - 1); start(); });
      if (n) n.addEventListener('click', function () { stop(); go(i + 1); start(); });
      bar.addEventListener('mouseenter', stop); bar.addEventListener('mouseleave', start);
      start();
    });
    var h = $('[data-nx-announce]'); if (h) de.style.setProperty('--nx-announce-h', h.offsetHeight + 'px');
  }

  /* gallery: scroll-snap track + thumbs + counter */
  function gallery() {
    $$('[data-nx-gallery]').forEach(function (g) {
      var tr = $('.nx-gal__track', g), slides = $$('.nx-gal__slide', g), th = $$('.nx-gal__thumb', g), c = $('[data-count]', g);
      if (!tr || !slides.length) return;
      var cur_ = 0;
      function set(i) {
        cur_ = i; th.forEach(function (t, k) { t.setAttribute('aria-current', k === i ? 'true' : 'false'); });
        if (c) c.textContent = (i + 1) + ' / ' + slides.length;
        var t = th[i]; if (t && t.parentNode.scrollWidth > t.parentNode.clientWidth) t.parentNode.scrollTo({ left: t.offsetLeft - 40, behavior: reduce ? 'auto' : 'smooth' });
      }
      function to(i) { i = Math.max(0, Math.min(slides.length - 1, i)); tr.scrollTo({ left: slides[i].offsetLeft - tr.offsetLeft, behavior: reduce ? 'auto' : 'smooth' }); set(i); }
      var raf; tr.addEventListener('scroll', function () { cancelAnimationFrame(raf); raf = requestAnimationFrame(function () { var i = Math.round(tr.scrollLeft / (tr.clientWidth || 1)); if (i !== cur_) set(i); }); }, { passive: true });
      th.forEach(function (t, k) { t.addEventListener('click', function () { to(k); }); });
      var pv = $('[data-prev]', g), nx = $('[data-next]', g);
      if (pv) pv.addEventListener('click', function () { to(cur_ - 1); });
      if (nx) nx.addEventListener('click', function () { to(cur_ + 1); });
      g.addEventListener('nx:media', function (e) { var k = slides.findIndex(function (s) { return s.getAttribute('data-media') == e.detail; }); if (k > -1) to(k); });
      set(0);
    });
  }

  /* product: variant picker, price, availability, add to cart */
  function product() {
    $$('[data-nx-product]').forEach(function (root) {
      var vj = $('[data-nx-variants]', root); if (!vj) return;
      var variants = JSON.parse(vj.textContent), form = $('form[data-nx-form]', root), idIn = $('input[name=id]', form);
      var fields = $$('[data-opt]', root), msg = $('[data-msg]', root);
      var priceEls = $$('[data-nx-price]', root.closest('[data-nx-scope]') || root), btns = $$('[data-nx-atc]', root.closest('[data-nx-scope]') || root);
      function selected() { return fields.map(function (f) { var s = $('select', f); if (s) return s.value; var r = $('input:checked', f); return r ? r.value : null; }); }
      function match(sel) { return variants.find(function (v) { return sel.every(function (o, i) { return o === null || v.options[i] === o; }); }); }
      function update() {
        var sel = selected(), v = match(sel);
        fields.forEach(function (f, i) { /* grey out values that no available variant offers with the other picks */
          $$('input,option', f).forEach(function (el) {
            var test = sel.slice(); test[i] = el.value;
            var m = variants.some(function (x) { return x.available && test.every(function (o, k) { return x.options[k] === o; }); });
            var lab = el.tagName === 'INPUT' ? el.nextElementSibling : el;
            if (lab) { lab.classList.toggle('is-na', !m); }
          });
          var out = $('[data-chosen]', f); if (out && sel[i]) out.textContent = sel[i];
        });
        if (!v) { btns.forEach(function (b) { b.disabled = true; b.querySelector('span').textContent = cfg.unavailable || 'Unavailable'; }); return; }
        idIn.value = v.id;
        priceEls.forEach(function (p) {
          var n = $('[data-p-now]', p), w = $('[data-p-was]', p), o = $('[data-p-off]', p);
          if (n) n.textContent = v.price; if (w) { w.textContent = v.compare || ''; w.hidden = !v.compare; } if (o) { o.textContent = v.off ? '-' + v.off + '%' : ''; o.hidden = !v.off; }
        });
        btns.forEach(function (b) { b.disabled = !v.available; var s = b.querySelector('span'); if (s) s.textContent = v.available ? (b.getAttribute('data-add') || 'Add to cart') : (b.getAttribute('data-sold') || 'Sold out'); });
        if (v.media) { var g = $('[data-nx-gallery]', root.closest('[data-nx-scope]') || d); if (g) g.dispatchEvent(new CustomEvent('nx:media', { detail: v.media })); }
        try { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u); } catch (e) {}
        root.dispatchEvent(new CustomEvent('nx:variant', { bubbles: true, detail: v }));
      }
      root.addEventListener('change', function (e) { if (e.target.closest('[data-opt]')) update(); });
      /* quantity */
      $$('.nx-qty', root).forEach(function (q) {
        var i = $('input', q); q.addEventListener('click', function (e) { var b = e.target.closest('button'); if (!b) return; var n = (parseInt(i.value, 10) || 1) + (b.hasAttribute('data-plus') ? 1 : -1); i.value = Math.max(1, Math.min(99, n)); });
      });
      /* add to cart via ajax; plain submit when it fails */
      form.addEventListener('submit', function (e) {
        if (!window.fetch) return; e.preventDefault();
        var main = $('[data-nx-atc]', root); main && main.classList.add('is-busy'); if (msg) msg.textContent = '';
        fetch((cfg.root || '/') + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
          .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
          .then(function () { main && main.classList.remove('is-busy'); return NX.refreshCart ? NX.refreshCart(true) : null; })
          .catch(function (err) { main && main.classList.remove('is-busy'); if (msg) msg.textContent = (err && (err.description || err.message)) || ''; });
      });
      update();
    });
  }

  /* sticky add to cart: visible once the main buy button leaves the screen */
  function sticky() {
    var s = $('[data-nx-sticky]'), target = $('[data-nx-buyzone]'); if (!s || !target || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (en) { var e = en[0]; s.classList.toggle('is-on', !e.isIntersecting && e.boundingClientRect.top < 0); }, { threshold: 0 });
    io.observe(target);
  }

  /* free shipping bar: threshold per currency (cfg.ship = {USD:7500,...} in minor units) else base x rate */
  function threshold() {
    var m = cfg.ship || {}, c = cur();
    if (m[c]) return m[c];
    var base = cfg.shipBase || 0; if (!base) return 0;
    var v = Math.round(base * rate() / 100); /* whole units */
    var step = v >= 100 ? 5 : 1; v = Math.ceil(v / step) * step;
    return v * 100;
  }
  function ship(total) {
    var t = threshold(); if (!t) return;
    if (total == null) total = (NX.cart && NX.cart.total_price) || cfg.cartTotal || 0;
    $$('[data-nx-ship]').forEach(function (el) {
      var left = Math.max(0, t - total), done = left === 0 && total > 0, empty = total === 0;
      el.style.setProperty('--p', Math.min(1, total / t).toFixed(3));
      el.classList.toggle('is-done', done);
      var tx = $('[data-ship-text]', el); if (!tx) return;
      var tpl = done ? el.getAttribute('data-done') : (empty ? el.getAttribute('data-empty') : el.getAttribute('data-left'));
      tx.innerHTML = (tpl || '').replace('{amount}', '<strong>' + money(left) + '</strong>').replace('{threshold}', '<strong>' + money(t) + '</strong>');
    });
  }

  /* cart drawer (Section Rendering API: the server renders the HTML, so money/markets stay correct) */
  function drawer() {
    var dr = $('[data-nx-drawer]'); if (!dr) return;
    var sec = dr.getAttribute('data-section') || 'nx-cart-drawer', root = cfg.root || '/';
    function open() { dr.classList.add('is-open'); dr.setAttribute('aria-hidden', 'false'); d.body.classList.add('nx-lock'); var x = $('.nx-drawer__x', dr); x && x.focus(); }
    function close() { dr.classList.remove('is-open'); dr.setAttribute('aria-hidden', 'true'); d.body.classList.remove('nx-lock'); }
    function swap(html) {
      var doc = new DOMParser().parseFromString(html, 'text/html'), n = $('[data-nx-drawer-inner]', doc), o = $('[data-nx-drawer-inner]', dr);
      if (n && o) o.innerHTML = n.innerHTML; dr.classList.remove('is-loading'); sync();
    }
    function sync() {
      var j = $('[data-nx-cart-json]', dr); if (j) { try { NX.cart = JSON.parse(j.textContent); } catch (e) {} }
      ship(); $$('[data-nx-count]').forEach(function (c) { c.textContent = NX.cart ? NX.cart.item_count : c.textContent; });
    }
    NX.refreshCart = function (andOpen) {
      dr.classList.add('is-loading');
      return fetch(root + '?sections=' + sec).then(function (r) { return r.json(); }).then(function (j) { swap(j[sec]); if (andOpen) open(); });
    };
    NX.openCart = open; NX.closeCart = close;
    d.addEventListener('click', function (e) {
      var t = e.target;
      if (t.closest('[data-nx-cart-open]')) { if (cfg.drawer === false) return; e.preventDefault(); NX.refreshCart(true); return; }
      if (t.closest('[data-nx-drawer-close]') || t.classList.contains('nx-drawer__ov')) { close(); return; }
      var ch = t.closest('[data-line-qty]');
      if (ch && dr.contains(ch)) {
        var line = ch.getAttribute('data-line'), q = parseInt(ch.getAttribute('data-line-qty'), 10);
        dr.classList.add('is-loading');
        fetch(root + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: line, quantity: q, sections: sec }) })
          .then(function (r) { return r.json(); }).then(function (j) { if (j.sections) swap(j.sections[sec]); else NX.refreshCart(); });
      }
    });
    d.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    sync();
  }

  /* UGC video strip: poster first, load + play only when on screen, tap for sound */
  function ugc() {
    var cards = $$('[data-nx-ugc] .nx-ugc__card[data-src]'); if (!cards.length) return;
    var io = 'IntersectionObserver' in window && new IntersectionObserver(function (en) {
      en.forEach(function (x) {
        var c = x.target, v = $('video', c);
        if (x.isIntersecting) {
          if (!v) { v = d.createElement('video'); v.muted = true; v.loop = true; v.playsInline = true; v.setAttribute('playsinline', ''); v.preload = 'metadata'; v.src = c.getAttribute('data-src'); c.insertBefore(v, c.firstChild); }
          if (!reduce) { var p = v.play(); p && p.catch(function () {}); c.classList.add('is-playing'); }
        } else if (v) { v.pause(); c.classList.remove('is-playing'); }
      });
    }, { threshold: 0.6 });
    cards.forEach(function (c) {
      io && io.observe(c);
      c.addEventListener('click', function (e) { if (e.target.closest('a')) return; var v = $('video', c); if (!v) return; if (v.muted) { v.muted = false; v.play(); c.classList.add('is-playing'); } else { v.muted = true; } });
    });
  }

  /* footer selectors submit on change */
  d.addEventListener('change', function (e) { var s = e.target.closest('[data-nx-autosubmit]'); if (s && s.form) s.form.submit(); });

  function init() { [reveal, announce, gallery, product, sticky, drawer, ugc, ship].forEach(function (f) { try { f(); } catch (e) { if (window.console) console.error('nx-kit', f.name, e); } }); }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', init); else init();
  d.addEventListener('shopify:section:load', function (e) { reveal(e.target); });
})();
